import { render, staticRenderFns } from "./ScissorsTopBarIcon.vue?vue&type=template&id=713aa1c2&"
import script from "./ScissorsTopBarIcon.vue?vue&type=script&lang=js&"
export * from "./ScissorsTopBarIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports